import {PRICING_CARD_DROPDOWN_OPTIONS} from "@/constants/cardPrices";
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    CostInfo: () => import('@/components/CostInfo.vue'),
  },

  data() {
    return {
      tab: 0,
      currentCategory: '',
      items: [],
      currentCostInfoUnilateral: {},
      currentCostInfoCollaborative: {},
      tabTitles: [],
      variant: '',
      collaborativeData: {},
      unilateralData: {},
      selectedCard: '',
      selectedColCard: '',
      collaborativePricing: {
        total: 0,
        levelOne: 0,
        levelTwo: 0,
      },
      unilateralPricing: {
        total: 0,
        levelOne: 0,
        levelTwo: 0,
      }
    }
  },

  computed: {
    ...mapGetters({
      prices: 'prices/getCardCosts'
    }),
    constantValue() {
      return PRICING_CARD_DROPDOWN_OPTIONS;
    },
  },

  methods: {
    ...mapActions({
      getAllPrices: 'prices/getPrices',
      saveItems: 'prices/saveListItems'
    }),
    editForm(evt) {
      if(evt.variant === 'collaborative') {
        this.items[0] = evt.data
        this.selectedColCardValuePreview(this.selectedColCard)
      } else if (evt.variant === 'unilateral') {
        this.items[1] = evt.data
        this.selectedCardValuePreview(this.selectedCard)
      }
      this.saveItems(evt)
    },
    selectedCardValuePreview(value) {
      this.selectedCard = value
      if(this.selectedCard === this.constantValue.WITHOUT_SPOUSE_LEVEL_ONE_PREVIEW) {
        this.currentCostInfoUnilateral = {
          img: this.items[1]?.level_1?.img,
          summary: this.items[1]?.level_1?.summary,
          title: this.items[1]?.level_1?.title,
          bg: this.items[1]?.level_1?.bg,
          fg: this.items[1]?.level_1?.fg,
          body: this.items[1]?.level_1?.body,
          items: this.items[1]?.level_1?.items,
          unilateralPricingLevels: this.unilateralPricing,
          previewChoice: this.constantValue.WITHOUT_SPOUSE_LEVEL_ONE_PREVIEW,
          tabs: [
            this.constantValue.WITHOUT_SPOUSE_GENERAL,
            this.constantValue.WITHOUT_SPOUSE_LEVEL_ONE,
            this.constantValue.WITHOUT_SPOUSE_LEVEL_TWO
          ]
        }
      } else if(this.selectedCard === this.constantValue.WITHOUT_SPOUSE_LEVEL_TWO_PREVIEW) {
        this.currentCostInfoUnilateral = {
          img: this.items[1]?.level_2?.img,
          summary: this.items[1]?.level_2?.summary,
          title: this.items[1]?.level_2?.title,
          bg: this.items[1]?.level_2?.bg,
          fg: this.items[1]?.level_2?.fg,
          body: this.items[1]?.level_2?.body,
          items: this.items[1]?.level_2?.items,
          unilateralPricingLevels: this.unilateralPricing,
          previewChoice: this.constantValue.WITHOUT_SPOUSE_LEVEL_TWO_PREVIEW,
          tabs: [
            this.constantValue.WITHOUT_SPOUSE_GENERAL,
            this.constantValue.WITHOUT_SPOUSE_LEVEL_ONE,
            this.constantValue.WITHOUT_SPOUSE_LEVEL_TWO
          ]
        }
      } else if(this.selectedCard === this.constantValue.WITHOUT_SPOUSE_GENERAL_PREVIEW) {
        this.currentCostInfoUnilateral = {
          img: this.items[1]?.WithoutSpouse?.img,
          summary: this.items[1]?.WithoutSpouse?.summary,
          title: this.items[1]?.WithoutSpouse?.title,
          bg: this.items[1]?.WithoutSpouse?.bg,
          fg: this.items[1]?.WithoutSpouse?.fg,
          body: this.items[1]?.WithoutSpouse?.body,
          items: this.items[1]?.WithoutSpouse?.items,
          unilateralPricingLevels: this.unilateralPricing,
          previewChoice: this.constantValue.WITHOUT_SPOUSE_GENERAL_PREVIEW,
          tabs: [
            this.constantValue.WITHOUT_SPOUSE_GENERAL,
            this.constantValue.WITHOUT_SPOUSE_LEVEL_ONE,
            this.constantValue.WITHOUT_SPOUSE_LEVEL_TWO
          ]
        } 
      }
    },
    selectedColCardValuePreview(value) {
      this.selectedColCard = value
      if(this.selectedColCard === this.constantValue.WITH_SPOUSE_LEVEL_ONE_PREVIEW) {
        this.currentCostInfoCollaborative = {
          img: this.items[0]?.level_1?.img,
          summary: this.items[0]?.level_1?.summary,
          title: this.items[0]?.level_1?.title,
          bg: this.items[0]?.level_1?.bg,
          fg: this.items[0]?.level_1?.fg,
          body: this.items[0]?.level_1?.body,
          items: this.items[0]?.level_1?.items,
          collaborativePricingLevels: this.collaborativePricing,
          previewChoice: this.constantValue.WITH_SPOUSE_LEVEL_ONE_PREVIEW,
          tabs: [
            this.constantValue.WITH_SPOUSE_GENERAL,
            this.constantValue.WITH_SPOUSE_LEVEL_ONE,
            this.constantValue.WITH_SPOUSE_LEVEL_TWO
          ]
        }
      } else if (this.selectedColCard === this.constantValue.WITH_SPOUSE_LEVEL_TWO_PREVIEW) {
        this.currentCostInfoCollaborative = {
          img: this.items[0]?.level_2?.img,
          summary: this.items[0]?.level_2?.summary,
          title: this.items[0]?.level_2?.title,
          bg: this.items[0]?.level_2?.bg,
          fg: this.items[0]?.level_2?.fg,
          body: this.items[0]?.level_2?.body,
          items: this.items[0]?.level_2?.items,
          collaborativePricingLevels: this.collaborativePricing,
          previewChoice: this.constantValue.WITH_SPOUSE_LEVEL_TWO_PREVIEW,
          tabs: [
            this.constantValue.WITH_SPOUSE_GENERAL,
            this.constantValue.WITH_SPOUSE_LEVEL_ONE,
            this.constantValue.WITH_SPOUSE_LEVEL_TWO
          ]
        }
      } else if (this.selectedColCard === this.constantValue.WITH_SPOUSE_GENERAL_PREVIEW) {
        this.currentCostInfoCollaborative = {
          img: this.items[0]?.WithSpouse?.img,
          summary: this.items[0]?.WithSpouse?.summary,
          title: this.items[0]?.WithSpouse?.title,
          bg: this.items[0]?.WithSpouse?.bg,
          fg: this.items[0]?.WithSpouse?.fg,
          body: this.items[0]?.WithSpouse?.body,
          items: this.items[0]?.WithSpouse?.items,
          collaborativePricingLevels: this.collaborativePricing,
          previewChoice: this.constantValue.WITH_SPOUSE_GENERAL_PREVIEW,
          tabs: [
            this.constantValue.WITH_SPOUSE_GENERAL,
            this.constantValue.WITH_SPOUSE_LEVEL_ONE,
            this.constantValue.WITH_SPOUSE_LEVEL_TWO
          ]
        }
      }      
    }
  },

  created() {
    this.selectedCard = this.constantValue.WITHOUT_SPOUSE_GENERAL_PREVIEW
    this.selectedColCard = this.constantValue.WITH_SPOUSE_GENERAL_PREVIEW
  },

  async mounted() {
    await this.getAllPrices()
    this.items = [this.prices[0], this.prices[1]];
    this.unilateralData = this.prices[1]
    this.collaborativeData = this.prices[0]
    this.collaborativePricing.total = this.prices[0].WithSpouse?.price
    this.collaborativePricing.levelOne = this.prices[0].level_1?.price
    this.collaborativePricing.levelTwo = this.prices[0].level_2?.price
    this.unilateralPricing.total = this.prices[1].WithoutSpouse?.price
    this.unilateralPricing.levelOne = this.prices[1].level_1?.price
    this.unilateralPricing.levelTwo = this.prices[1].level_2?.price
    this.currentCostInfoCollaborative = {
      img: this.items[0]?.WithSpouse?.img,
      summary: this.items[0]?.WithSpouse?.summary,
      price: this.collaborativePricing.total,
      title: this.items[0]?.WithSpouse?.title,
      bg: this.items[0]?.WithSpouse?.bg,
      fg: this.items[0]?.WithSpouse?.fg,
      body: this.items[0]?.WithSpouse?.body,
      items: this.items[0]?.WithSpouse?.items,
      collaborativePricingLevels: this.collaborativePricing,
      previewChoice: this.constantValue.WITH_SPOUSE_GENERAL_PREVIEW,
      tabs: [
        this.constantValue.WITH_SPOUSE_GENERAL,
        this.constantValue.WITH_SPOUSE_LEVEL_ONE,
        this.constantValue.WITH_SPOUSE_LEVEL_TWO
      ]
    }

    this.currentCostInfoUnilateral = {
      img: this.items[1]?.WithoutSpouse?.img,
      summary: this.items[1]?.WithoutSpouse?.summary,
      price: this.unilateralPricing.total,
      title: this.items[1]?.WithoutSpouse?.title,
      bg: this.items[1]?.WithoutSpouse?.bg,
      fg: this.items[1]?.WithoutSpouse?.fg,
      body: this.items[1]?.WithoutSpouse?.body,
      items: this.items[1]?.WithoutSpouse?.items,
      unilateralPricingLevels: this.unilateralPricing,
      previewChoice: this.constantValue.WITHOUT_SPOUSE_GENERAL_PREVIEW,
      tabs: [
        this.constantValue.WITHOUT_SPOUSE_GENERAL,
        this.constantValue.WITHOUT_SPOUSE_LEVEL_ONE,
        this.constantValue.WITHOUT_SPOUSE_LEVEL_TWO
      ]
    }    
  }
}